import ShiftPatternPage from './ShiftPatternPage';

export default ShiftPatternPage;
